module.exports = __webpack_public_path__ + "static/media/8a.479382ae.png";